// Placing faces on one picture of a timeline: the shared Placer, drawn as the timeline draws that picture (so each
// person has their feeling at that time). Adds the cast picker's references. Used by a picture's Faces stage and the
// frame faces page (one frame of an animation).
import type { Picture } from "../../../model/episode";
import type { PaintSource, PlacedFace, TimelineEpisode } from "../../../model/timeline";
import { Placer, type PlacerFrames } from "../../placer/Placer";
import { facesFrame } from "./shared";

export function FacePlacing({ ep, t, picture, faces, onFaces, fixedCast, refs, hint, frames }: {
  ep: TimelineEpisode; t: number; picture: Picture; faces: PlacedFace[]; onFaces: (faces: PlacedFace[]) => void;
  fixedCast?: boolean; refs?: PaintSource[]; hint?: string; frames?: PlacerFrames;
}) {
  return <Placer picture={picture} faces={faces} onFaces={onFaces} fixedCast={fixedCast} refs={refs} hint={hint} frames={frames}
    draw={({ clock, camera, talk }) => facesFrame(ep, t, clock, picture, faces, camera, talk)} />;
}
